import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
  title = 'Api Docs',
}: any) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-apidocs-2 { fill: none; }
          .svg-fill-apidocs { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <path
          className="svg-fill-apidocs"
          d="M11.54,20.89c0-.27,0-.58.05-.89s0-.5.05-.73a1.89,1.89,0,0,0-1-2c.76-.36,1-.9,1-2,0-.2,0-.51-.05-.83s-.05-.66-.05-.89c0-.86.21-1.3,1.37-1.37h.25l0-1.4h-.25c-2,.08-2.86.87-2.86,2.72,0,.28,0,.67.05,1s0,.58,0,.76c0,.59-.23,1-1.31,1.29l-.19,0V17.9L8.8,18c1.09.31,1.32.75,1.32,1.33,0,.15,0,.39,0,.66s-.06.74-.06,1c0,1.82.85,2.63,2.84,2.7h.26l0-1.4-.25,0C11.76,22.22,11.54,21.75,11.54,20.89Z"
        />
        <path
          className="svg-fill-apidocs"
          d="M21.19,16.62c-1.08-.26-1.31-.7-1.31-1.29,0-.18,0-.46.05-.76s.05-.75.05-1c0-1.85-.83-2.64-2.86-2.72h-.25l0,1.4h.24c1.16.07,1.37.51,1.37,1.37,0,.23,0,.57-.05.89s-.05.63-.05.83c0,1.06.25,1.6,1,2-.74.37-1,.94-1,2,0,.22,0,.47.05.72s.05.62.05.89c0,.86-.22,1.33-1.37,1.39l-.25,0,0,1.4h.26c2-.07,2.84-.88,2.84-2.7,0-.31,0-.7-.06-1s0-.51,0-.66c0-.58.23-1,1.32-1.33l.18-.05V16.66Z"
        />
        <rect className="svg-apidocs-2" width="30" height="30" />
        <path
          className="svg-fill-apidocs"
          d="M25.31,8.07,19.89,2.69a.67.67,0,0,0-.47-.19H5.16a.66.66,0,0,0-.66.66V26.84a.66.66,0,0,0,.66.66H24.84a.66.66,0,0,0,.66-.66V8.53A.66.66,0,0,0,25.31,8.07Zm-1.5,17.74-17.62,0,0-21.66,12.14,0V8.89a.66.66,0,0,0,.65.66l4.86,0Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
